/**
 * The one place VAT is named for a human.
 *
 * "FV 8%" is an invoice type, not a tax rate — printing it on a client offer
 * next to an amount reads as "faktura", which is a different promise than the
 * VAT rate the price actually carries. The labels live here so the screen, the
 * wizard and the PDF cannot drift apart, and so a test can assert on the same
 * producer the document uses instead of hand-writing the expected string.
 */

export type VatSettlementMode = 'no_vat' | 'vat_8' | 'vat_23' | 'confirm';

/** How the settlement is named in the UI and on the offer's summary line. */
export function getVatSettlementLabel(mode: VatSettlementMode): string {
  if (mode === 'vat_8') return 'VAT 8%';
  if (mode === 'vat_23') return 'VAT 23%';
  if (mode === 'confirm') return 'VAT do potwierdzenia';
  return 'Bez VAT / zwolniony';
}

/** How the VAT row is labelled inside the generated document. */
export function getVatDocumentLabel(mode: VatSettlementMode): string {
  if (mode === 'confirm') return 'VAT: do potwierdzenia';
  if (mode === 'no_vat') return 'VAT: nie doliczono / zwolniony';
  return getVatSettlementLabel(mode);
}
